import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/download.svg
 */
const IconDownload: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path d="M9.778 2h4.444v8.889H9.778V2z" fill="currentColor" />
    <path d="M5.333 10.056h13.334L12 16.86l-6.667-6.805z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.944 15.333H3c-.552 0-1 .508-1 1.135v4.397C2 21.492 2.448 22 3 22h18c.552 0 1-.508 1-1.135v-4.397c0-.627-.448-1.135-1-1.135h-5.944L12 18.373l-3.056-3.04zm-5.833 1.111h2.222v1.112H3.111v-1.112zm4.445 0H6.444v1.112h1.112v-1.112z"
      fill="currentColor"
    />
  </svg>
);

export default IconDownload;
